import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchFeatureFlagsSuccess,
  fetchFeatureFlagsFail,
} from './actions';
import * as CONSTANTS from './constants';
import request from '@iso/lib/helpers/httpClient';


function* fetchFeatureFlags() {
  try {
    const data = yield call(request, '/feature-flags', 'GET', null, true);
    yield put(fetchFeatureFlagsSuccess(data));
  } catch (error) {
    yield put(fetchFeatureFlagsFail(error));
  }
}

export default function* featureFlagsSaga() {
  yield takeLatest(CONSTANTS.FETCH_FEATURE_FLAGS_REQUEST, fetchFeatureFlags);
}